import React from 'react';
import { BRAND } from '../mock';

export default function Studio() {
  return (
    <section id="studio" className="py-24 md:py-32 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="relative rounded-xl overflow-hidden border-2 border-[#FF5C4D]">
            <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
            <img
              src="https://customer-assets-v7afamib.emergentagent.net/job_anitix-preview/artifacts/ovdq3s5a_1525951925769.jpeg"
              alt="Sai, Director"
              className="w-full h-[420px] object-cover object-top"
              style={{ filter: 'grayscale(85%) contrast(1.05)' }}
            />
          </div>
        </div>
        <div className="lg:col-span-7 lg:pl-8">
          <div className="eyebrow mono-font text-black/60">The Studio</div>
          <h2 className="display-font mt-8 text-[10vw] md:text-[4.6rem] leading-[0.95]">
            Built by <span className="accent-red">operators.</span>
          </h2>
          <p className="mt-8 text-black/60 max-w-xl">
            Anitix.cloud is the software and staffing arm of {BRAND.parent} — a studio obsessed with putting the right people on the right problems, fast.
          </p>
          <p className="mt-4 text-black/60 max-w-xl">
            We pair a deep bench of vetted engineers with a hands-on delivery culture, so clients get the reliability of an agency with the velocity of an in-house team.
          </p>
          <div className="mt-10">
            <div className="display-font text-2xl md:text-3xl text-black">Sai</div>
            <div className="mono-font mt-2 text-black/50">Director, {BRAND.parent}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
